<template>
  <div id="footer" class="container-fluid" style="padding-top:20px">
<!--    <div class="logo">-->
<!--      <img src="@/assets/img/shilelogo.png" alt="logo图">-->
<!--    </div>-->
    <p class="title">沙河市施乐工程复印部</p>
    <p class="address_tel_fax">
      <span>地址：河北省邢台市沙河市太行大街687号，市政府西侧CAD门市</span>
      <span>Tel：13513191191</span>
    </p>
    <p class="email_wx">
      <span>邮箱：1151130257@qq.com</span>
      <span>微信号：13513191191</span>
    </p>
    <p class="copy">Copyright &copy; 2025 - {{ new Date().getFullYear() }} 沙河市施乐工程复印部 &nbsp; &nbsp; <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61011302001964" rel="noreferrer" target="_blank">冀公网安备13058202001940号 冀ICP备2025107250号</a></p>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /*margin: 50px 0 10px;*/
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue